module.exports = __webpack_public_path__ + "static/media/newsCalendar.62ff9229.png";